const pick = (object, ...keys) => {
    // eslint-disable-next-line no-restricted-syntax
    return Object.fromEntries(keys.map((key) => [key, object[key]]));
};
const pickState = (...keys) => (state) => pick(state, ...keys);

export { pick, pickState };
